import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'
// Via reactrouter.com
// URLSearchParams is not supported by IE. Might want to use query-string if we need to support it
export const useGlobalSearchQuery = () => {
  const { search } = useLocation()
  return useMemo(() => new URLSearchParams(search), [search])
}
